import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import BaseGynObsReport from "./BaseGynObsReport";

const ANCRegisterReport = ({ actions }) => (
  <BaseGynObsReport
    title="ANC Register Report"
    endpoint="obgyn/reports/anc-register"
    actions={actions}
    columns={[
      { key: "anc_number", label: "ANC No." },
      { key: "booking_date", label: "Booking Date" },
      { key: "patient_number", label: "Patient No." },
      { key: "patient_name", label: "Patient Name" },
      { key: "phone_no", label: "Phone" },
      { key: "edd", label: "Expected Delivery Date" },
      { key: "gestational_age_at_booking", label: "GA (weeks)" },
    ]}
  />
);

const mapDispatchToProps = (dispatch) => ({
  actions: {
    snackbarActions: bindActionCreators(snackbarActions, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(ANCRegisterReport);
